module.exports = __webpack_public_path__ + "img/IP.9093c64f.png";